module.exports = __webpack_public_path__ + "static/media/graphic.80f1eb85.jpg";